import { svSE, enUS } from "./languages";

export type SupportedLanguages = "sv" | "en";
export const messages = {
  sv: svSE,
  en: enUS,
};

type Videos = {
  [key in SupportedLanguages]: {
    [key in VideoIds]: string;
  };
};

const videoUrl = (id: string) => `https://player.vimeo.com/video/${id}?badge=0&autopause=0&player_id=0&app_id=58479`;
export type VideoIds = "getStarted" | "testHowTo";
export const videos: Videos = {
  sv: {
    getStarted: videoUrl("1080153775"),
    testHowTo: videoUrl("1080154558"),
  },
  // TODO: Add English videos when we get them
  en: {
    getStarted: videoUrl("1080152201"),
    testHowTo: videoUrl("1080155576"),
  },
};
